/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from "react";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import DreamStreamAdd from "./DreamStreamAdd";
import DreamStreamHistory from "./DreamStreamHistory";
import DreamStreamDetails from "./DreamStreamDetails";

import Loader from "shared/Loader";
import { useDreamStream } from "./useDreamStream";

export default function ({ iboNumber, membership }) {
  const [iboA, setIboA] = useState(null);
  const [isAddingIboA, setIsAddingIboA] = useState(false);
  const [isDisplayingHistoryIboA, setIsDisplayingHistoryIboA] = useState(false);
  const [isDisplayingDetailsIboA, setIsDisplayingDetailsIboA] = useState(false);

  const [iboB, setIboB] = useState(null);
  const [isAddingIboB, setIsAddingIboB] = useState(false);
  const [isDisplayingHistoryIboB, setIsDisplayingHistoryIboB] = useState(false);
  const [isDisplayingDetailsIboB, setIsDisplayingDetailsIboB] = useState(false);

  const [accessCodeIboA, setAccessCodeIboA] = useState("");
  const [accessCodeIboB, setAccessCodeIboB] = useState("");

  const didRetrieveAccessCode = (accessCodeToDisplay, contactToUpdate) => {
    if (
      contactToUpdate &&
      contactToUpdate.iboInfo &&
      contactToUpdate.iboInfo.type &&
      contactToUpdate.iboInfo.type === "IBO-A"
    ) {
      setAccessCodeIboA(accessCodeToDisplay);
    } else {
      setAccessCodeIboB(accessCodeToDisplay);
    }
  };

  const didRefetch = (contactToUpdate) => {
    if (
      contactToUpdate &&
      contactToUpdate.iboInfo &&
      contactToUpdate.iboInfo.type === "IBO-A"
    ) {
      setIboA(contactToUpdate);
      if (
        contactToUpdate &&
        contactToUpdate.dreamStream &&
        contactToUpdate.dreamStream.isComplete
      ) {
        setIsDisplayingHistoryIboA(false);
        setIsDisplayingDetailsIboA(true);
      }
    }

    if (
      contactToUpdate &&
      contactToUpdate.iboInfo &&
      contactToUpdate.iboInfo.type === "IBO-B"
    ) {
      setIboB(contactToUpdate);
    }
  };

  const didCreateDreamStreamAccount = (contactToAdd) => {
    if (contactToAdd && contactToAdd.type === "IBO-A") {
      let iboAToAdd = {
        iboNumber: contactToAdd.iboNumber,
        wwgId: contactToAdd.wwgId,
        iboInfo: {
          name: contactToAdd.name,
          email: contactToAdd.email,
          type: "IBO-A",
        },
        dreamStream: null,
        actions: [],
        isComplete: false,
        isSyncing: true,
      };

      setIsAddingIboA(false);
      setIboA(iboAToAdd);
      setIsDisplayingHistoryIboA(true);
    }

    if (contactToAdd && contactToAdd.type === "IBO-B") {
      let iboBToAdd = {
        iboNumber: contactToAdd.iboNumber,
        wwgId: contactToAdd.wwgId,
        iboInfo: {
          name: contactToAdd.name,
          email: contactToAdd.email,
          type: "IBO-B",
        },
        dreamStream: null,
        actions: [],
        isComplete: false,
        isSyncing: true,
      };

      setIsAddingIboB(false);
      setIboB(iboBToAdd);
      setIsDisplayingHistoryIboB(true);
    }
  };

  const {
    data,
    error,
    loading,

    addDreamStreamAccount,
    refetch,
    syncDreamStreamAccount,
    fetchIboSyncData,
    retrieveAccessCode,
  } = useDreamStream(
    iboNumber,
    didCreateDreamStreamAccount,
    didRefetch,
    didRetrieveAccessCode
  );

  const { cancelHistoryPut } = useDreamStream(iboNumber);

  const clearAccessCode = () => {
    setAccessCodeIboA("");
    setAccessCodeIboB("");
  };

  useEffect(() => {
    if (iboA && !iboA.dreamStream && !iboA.isSyncing) {
      setIsAddingIboA(true);
    } else if (iboA && !iboA.dreamStream && iboA.isSyncing) {
      setIsDisplayingHistoryIboA(true);
    } else if (iboA && iboA.dreamStream) {
      setIsDisplayingDetailsIboA(true);
    }
  }, [iboA]);

  useEffect(() => {
    if (iboB && !iboB.dreamStream && !iboB.isSyncing) {
      setIsAddingIboB(true);
    } else if (iboB && !iboB.dreamStream && iboB.isSyncing) {
      setIsDisplayingHistoryIboB(true);
    } else if (iboB && iboB.dreamStream) {
      setIsDisplayingDetailsIboB(true);
    }
  }, [iboB]);

  useEffect(() => {
    if (data && data.iboA) {
      setIboA(data.iboA);
    }

    if (data && data.iboB) {
      setIboB(data.iboB);
    }
  }, [data]);

  const handleCancel = (contact) => {
    cancelHistoryPut.mutate({
      iboNumber: contact.iboNumber,
      wwgId: contact.wwgId,
    });
  };

  return (
    <div>
      {data == null || loading ? (
        <Loader />
      ) : (
        <div>
          {iboA == null && (
            <AlertNotice icon={<Danger />} title="Error Encountered">
              <div>
                An error occurred retrieving DreamStream 2.0 data. Please report
                this issue to QA.
              </div>
            </AlertNotice>
          )}

          {isAddingIboA && (
            <DreamStreamAdd
              data={iboA}
              onSubmit={async (contact) => {
                await addDreamStreamAccount(contact);
              }}
              membership={membership}
            />
          )}

          {isDisplayingHistoryIboA && (
            <DreamStreamHistory
              ibo={iboA}
              isCreatingIbo={iboA.isSyncing}
              isShowHistory={false}
              refresh={async (contact) => {
                await refetch(contact);
              }}
              onClose={() => {
                setIsDisplayingHistoryIboA(false);
              }}
              onCancel={handleCancel}
            ></DreamStreamHistory>
          )}

          {isDisplayingDetailsIboA && (
            <DreamStreamDetails
              refetch={refetch}
              syncDreamStreamAccount={syncDreamStreamAccount}
              fetchIboSyncData={fetchIboSyncData}
              data={iboA}
              hideHeader={isDisplayingHistoryIboA}
              retrieveAccessCode={retrieveAccessCode}
              accessCode={accessCodeIboA}
              clearAccessCode={clearAccessCode}
              membership={membership}
            />
          )}

          {isAddingIboB && (
            <DreamStreamAdd
              data={iboB}
              onSubmit={async (contact) => {
                await addDreamStreamAccount(contact);
              }}
              membership={membership}
            />
          )}

          {isDisplayingHistoryIboB && (
            <DreamStreamHistory
              ibo={iboB}
              isCreatingIbo={iboB.isSyncing}
              isShowHistory={false}
              refresh={async (contact) => {
                await refetch(contact);
              }}
              onClose={() => {
                setIsDisplayingHistoryIboB(false);
              }}
              onCancel={handleCancel}
            ></DreamStreamHistory>
          )}

          {isDisplayingDetailsIboB && (
            <DreamStreamDetails
              refetch={refetch}
              syncDreamStreamAccount={syncDreamStreamAccount}
              fetchIboSyncData={fetchIboSyncData}
              data={iboB}
              hideHeader={isDisplayingHistoryIboB}
              retrieveAccessCode={retrieveAccessCode}
              accessCode={accessCodeIboB}
              clearAccessCode={clearAccessCode}
              membership={membership}
            />
          )}
        </div>
      )}
    </div>
  );
}
